import type { PropsWithChildren, ReactNode } from "react";
import type {
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
} from "react-hook-form";
import styled from "styled-components";
import { smallStrongStyles } from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const Container = styled.div<{ $single?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  grid-column: ${({ $single }) => ($single ? "1 / 3" : "auto")};
  gap: 0.375rem;
`;

export const Label = styled.label`
  ${smallStrongStyles};
  padding: 0 0 0 0.1rem;
  width: max-content;
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren {
  name?: string;
  label?: string | ReactNode;
  error?:
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<FieldValues>>
    | Merge<FieldError, (FieldError | undefined)[]>;
  className?: string;
  $single?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
